module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEsSURBVEhL5ZQ7TsNAFEUtJPZAwWIoiBChYQnsBHZGG1HRImiSEKjYguGMOTPOxB7M8GngSE+27n2+817haf4PbdueUU/WqfL3MPSR2lAvrxLeqXBQ8Oa218PHazOL0LOy/XPwQZz6wYxJQq/fTG9D0+jU6Nc8jkL5PgC9vA1mN7m9iRhsWyJoYweFDGq4CeLo5NpFbMsga7gJ4lI/Q3sQpFw6YKndg371budo1x5wqd3z6xsgPutnaBexLYOsjXYP4kw/Q7uIbbsca+eUtqhhdPpIaYtKxqePcEj6H3iPl9q9UiJo1O4lOH0v0TSn1lT4I9O1bEZCOfaHIVbUiXI95iaUfwYmOzR3mwPtr0PIPnXBAXdd5BZotzzOqT3b6yHkpkv7AHoWtv9JmuYNgZXJF0efg2UAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-treehouse/light/24.png
// module id = 2520
// module chunks = 2